import * as HTTP from "./http";
import { ITank, IRackStats } from "@/types/data";
import { IListApiReponse } from "@/types/api";

export function getTanks(nurseryId: string): Promise<IListApiReponse<ITank>> {
  return HTTP.get(`/api/v1/nurseries/${nurseryId}/tanks/`)
    .then(r => {
      if (!r.ok) throw new Error("Unable to get tanks.");
      return r.json();
    });
}

export function getTank(nurseryId: string, tankId: string|number): Promise<ITank> {
  return HTTP.get(`/api/v1/nurseries/${nurseryId}/tanks/${tankId}/`)
    .then(r => {
      if (r.status === 404) throw new Error("Tank not found.");
      if (!r.ok) throw new Error("Unable to get tank.");
      return r.json();
    });
}

export function getTankStats(nurseryId: string, tankId: string|number): Promise<IRackStats[]> {
  return HTTP.get(`/api/v1/nurseries/${nurseryId}/tanks/${tankId}/stats/`)
    .then(r => {
      if (r.status === 404) throw new Error("Tank not found.");
      if (!r.ok) throw new Error("Unable to get tank. Please try again.");

      return r.json();
    });
}
